import { BaseChatPackage } from '../utils'
import { MembersQuery } from './members'
export class ChatQueries extends BaseChatPackage {  
  public members: MembersQuery

  constructor(...args: ConstructorParameters<typeof BaseChatPackage>) {
    super(...args)
    this.members = new MembersQuery(...args)
  }
}


